import React from "react";
import { Box, Typography } from "@mui/material";
import ArrowButton from "../buttons/arrowButton";

const Tile = ({
                       title,
                       preTitle,
                       description,
                       image,
                       align = "left",
                       onClick,
                       aspectRatio,
                       sx = {},
                   }) => {
    const isLeft = align === "left";

    return (
        <Box
            onClick={onClick}
            sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                height: "100%",
                borderRadius: "30px",
                position: "relative",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                alignSelf: "stretch",
                cursor: onClick ? "pointer" : "default",

                ...(aspectRatio ? { aspectRatio } : {}),

                "&:hover .banner-bg": { transform: "scale(1.06)" },

                ...sx,
            }}
        >
            <Box
                className="banner-bg"
                sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url(${image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                    transition: "transform .6s ease",
                    transformOrigin: "center",
                    willChange: "transform",
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                        "linear-gradient(180deg, rgba(0,0,0,0.50) 0%, rgba(0,0,0,0.10) 60%, rgba(0,0,0,0) 100%)",
                    zIndex: 1,
                }}
            />

            <Box
                sx={{
                    position: "relative",
                    zIndex: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    px: { xs: 2, md: 4 },
                    py: { xs: 2, md: 3 },
                    textAlign: isLeft ? "left" : "right",
                    color: "#fff",
                    minWidth: 0,
                }}
            >
                <Box sx={{ minWidth: 0 }}>
                    {preTitle && (
                        <Typography
                            sx={{
                                fontFamily: "'Roboto Condensed', Arial, sans-serif",
                                fontWeight: 700,
                                mb: 1,
                                color: "#FFFFFF",
                                fontSize: 14,
                                lineHeight: "90%",
                                letterSpacing: "0.05em",
                            }}
                        >
                            {preTitle}
                        </Typography>
                    )}

                    <Typography
                        component="h3"
                        sx={{
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontWeight: 900,
                            fontSize: { xs: 18, sm: 22, md: 36 },
                            lineHeight: "110%",
                            textTransform: "uppercase",
                            color: "#F0F0F0",
                            mb: 1.2,
                            wordBreak: "break-word",
                        }}
                    >
                        {title}
                    </Typography>

                    {!!description && (
                        <Typography
                            sx={{
                                fontFamily: "'Roboto Condensed', Arial, sans-serif",
                                fontSize: { xs: 12, sm: 14, md: 16 },
                                fontWeight: 700,
                                lineHeight: "120%",
                                color: "#FFFFFF",
                                maxWidth: { xs: "100%", md: "85%" },
                            }}
                        >
                            {description}
                        </Typography>
                    )}
                </Box>

                {/*  60x60 bottom-right */}
                <Box sx={{ position: "relative", width: "100%", mt: 1 }}>
                    <Box
                        sx={{
                            position: "absolute",
                            right: { xs: 12, md: 15 },
                            bottom: { xs: 12, md: 15 },
                            zIndex: 5,
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            onClick?.();
                        }}
                    >
                        <ArrowButton />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default Tile;
